export const CLAIM_TYPE_OUTLET_REQUIREMENT = {
    VISIBILITY_INCENTIVE: 'required',
    NPD_LISTING: 'required',
    PROMO_DISCOUNT_SUBSIDY: 'required',
    SAMPLING_ACTIVITY: 'required',
    OUTLET_RETURN: 'required',
    DAMAGE_EXPIRY: 'optional',
    SALES_TEAM_INCENTIVE: 'hidden',
    MEMO_REDEMPTION: 'hidden',
    VOLUME_REBATE: 'hidden',
    COOP_MARKETING: 'optional',
    TRADE_SPEND_DRAWDOWN: 'hidden',
    OTHER: 'optional',
};
//# sourceMappingURL=claimTypeMetadata.js.map